import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import SelectableButton from './SelectableButton';
import './SelectableButtonPanel.scss';

type SelectableButtonPanelProps = {
    onClicked: (selected: boolean) => void;
    id: string;
    selected: boolean;
    style?: React.CSSProperties;
    buttonText?: string;
    children?: React.ReactNode;
};

const SelectableButtonPanel = memo(SelectableButtonPanelMemo);

function SelectableButtonPanelMemo({
    onClicked,
    id,
    selected,
    style,
    buttonText,
    children
}: SelectableButtonPanelProps): JSX.Element {
    const { t } = useTranslation();

    return (
        <div id={id} className='selectable-button-container' style={style}>
            <div className='options-container'>{children}</div>
            <div className='button-container'>
                <SelectableButton
                    id={`selectable-button-${id}`}
                    text={buttonText || t('select')}
                    onClicked={onClicked}
                    selected={selected}
                />
            </div>
        </div>
    );
}

export default SelectableButtonPanel;
